// src/components/common/Logo.tsx
import React from 'react';

interface LogoProps {
  className?: string;
  showText?: boolean;
  size?: 'small' | 'medium' | 'large' | 'xl';
}

const Logo: React.FC<LogoProps> = ({ className = '', showText = false, size = 'large' }) => {
  const sizeClasses = {
    small: 'h-8',
    medium: 'h-12',
    large: 'h-16',
    xl: 'h-20',
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src="/assets/images/logo-box1.png"
        alt="Ballotr logo"
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
      {(showText || size === 'large' || size === 'xl') && (
        <span className="text-3xl font-bold text-gray-800">ballotr</span>
      )}
    </div>
  );
};

export default Logo;